import { FunctionComponent } from 'react';
import AppointmentsWebSockets from './AppointmentsWebSockets';
import BulkUploadWebSockets from './BulkUploadWebSocket';
import MarketplaceWebSockets from './MarketplaceWebSocket';
import StaffWebSockets from './StaffWebSocket';
import InboxWebSockets from './InboxWebSockets';
import TwoWaySmsWebSockets from './TwoWaySmsWebSockets';
import UserNotificationsWebSockets from './UserNotificationsWebsocket';

/** Global WebSocket subscriptions mounted once per authenticated session. */
const WebSocketManager: FunctionComponent = () => (
    <>
        <AppointmentsWebSockets />
        <TwoWaySmsWebSockets />
        <InboxWebSockets />
        <BulkUploadWebSockets />
        <MarketplaceWebSockets />
        <StaffWebSockets />
        <UserNotificationsWebSockets />
    </>
);

export default WebSocketManager;
